import React, {useEffect, useState} from 'react';
import {Flex, Form, Input, message, Modal, Upload} from "antd";
import IntlMessage, {IntlMessageText} from "../../../../../components/IntlMessage/IntlMessage";
import classes from "../../Applications/application.module.css";
import FormItem from "antd/es/form/FormItem";
import {useTranslation} from "react-i18next";
import MicroQualificationService from "../../../../../services/MicroQualificationService";
import {useDispatch, useSelector} from "react-redux";
import MyText from "../../../../../components/UI/Text/MyText";
import {changeCurrentPage} from "../../../../../store/slices/tableController/PartnerOrgListTableController";
import BlackerBlueButton from "../../../../../components/UI/Buttons/BlackerBlueButton";
import MyTable from "../../../../../components/Table/MyTable";
import {getAllPartnerOrganizations} from "../../../../../store/slices/PartnerOrganizationsSlice";
import {getAllGroupEps} from "../../../../../store/slices/GroupEpsSlice";
import GreenButton from "../../../../../components/UI/Buttons/GreenButton";
import BhargaButton from "../../../../../components/UI/Buttons/BhargaButton";
import {UploadOutlined} from "@ant-design/icons";

const PartnerOrganizationPage = () => {
    const [form] = Form.useForm();
    const {t} = useTranslation();
    const dispatch = useDispatch();

    const {partnerOrgs, isLoading, hasMore, error} = useSelector(state => state.partnerOrganizationList)
    const {currentPage, pageSize} = useSelector(state => state.partnerOrgListTableController);

    const nameRu = Form.useWatch('nameRu', form);
    const nameKz = Form.useWatch('nameKz', form);
    const nameEng = Form.useWatch('nameEng', form);
    const image = Form.useWatch('image', form);
    const firstName = Form.useWatch('firstName', form);
    const lastName = Form.useWatch('lastName', form);
    const middleName = Form.useWatch('middleName', form);
    const firstNameEng = Form.useWatch('firstNameEng', form);
    const lastNameEng = Form.useWatch('lastNameEng', form);
    const positionRu = Form.useWatch('positionRu', form);
    const positionKz = Form.useWatch('positionKz', form);
    const positionEng = Form.useWatch('positionEng', form);
    const workPlaceRu = Form.useWatch('workPlaceRu', form);
    const workPlaceKz = Form.useWatch('workPlaceKz', form);
    const workPlaceEng = Form.useWatch('workPlaceEng', form);

    const [isLoadingCreate, setIsLoadingCreate] = useState(false);
    const [openModal, setOpenModal] = useState(false)

    const [uploadedFile, setUploadedFile] = useState(null);
    const [uploadedImage, setUploadedImage] = useState(null);

    const columns = [
        {
            title: <MyText center strong><IntlMessage id={"nameRu"}/></MyText>,
            render: (_, record) => (
                <MyText center>{record.nameRu}</MyText>
            ),
            width: '33%',
        },
        {
            title: <MyText center strong><IntlMessage id={"nameKz"}/></MyText>,
            render: (_, record) => (
                <MyText center>{record.nameKz}</MyText>
            ),
            width: '33%',
        },
        {
            title: <MyText center strong><IntlMessage id={"nameEng"}/></MyText>,
            render: (_, record) => (
                <MyText center>{record.nameEng}</MyText>
            ),
            width: '33%',
        },

    ];

    function handleCreate() {
        form.validateFields()
            .then(async (values) => {
                setIsLoadingCreate(true);
                setOpenModal(false)
                await MicroQualificationService.savePartnerOrganization(nameRu, nameKz, nameEng, uploadedImage, firstName, lastName, middleName, firstNameEng, lastNameEng, positionRu, positionKz, positionEng, workPlaceRu, workPlaceKz, workPlaceEng)
                    .then(() => {
                        message.success(<IntlMessage id={'success'}/>)
                        form.resetFields();
                        setUploadedImage(null);
                    })
                    .catch()
                    .finally()
            })
            .catch((error) => {
                console.log("Validation error!", error);
            })
            .finally(() => {
                dispatch(getAllPartnerOrganizations({
                    page: currentPage,
                    limit: pageSize
                }))
                setIsLoadingCreate(false);
                message.destroy();
            });
    }

    useEffect(() => {
        dispatch(getAllPartnerOrganizations({
            page: currentPage,
            limit: pageSize
        }));
    }, []);

    const fetchData = async (params) => {
        return dispatch(getAllPartnerOrganizations({
            ...params
        }));
    }

    const saveCurrentPageSettings = (page, pageSize) => {
        dispatch(changeCurrentPage({page: page, pageSize: pageSize}));
    };

    const handleChangeExcel = (info) => {
        setUploadedFile(info.file);
    };

    const propsExcelFile = {
        beforeUpload: () => false,
        onChange: handleChangeExcel,
        multiple: false,
    };

    const handleChangeImage = (info) => {
        setUploadedImage(info.file);
    };

    const propsImageFile = {
        beforeUpload: () => false,
        onChange: handleChangeImage,
        multiple: false,
        accept: 'image/*',
    };

    const handleImportExcelFile = async () => {
        setIsLoadingCreate(true);
        await MicroQualificationService.importPartnerOrganizationsByExcel(uploadedFile)
            .then(() => {
                message.success(<IntlMessage id={'success'}/>)
                setUploadedFile(null);
            })
            .catch()
            .finally(() => {
                dispatch(getAllGroupEps({
                    page: currentPage,
                    limit: pageSize
                }))
                setIsLoadingCreate(false);
                message.destroy();
            })
    }

    return (
        <Flex style={{width: "100%"}} gap={20} align={"flex-start"} justify={"flex-start"} vertical>
            <MyText uppercase strong size={"large"}><IntlMessage id={'partnerOrg'}/></MyText>
            <Flex gap={"large"} justify={"center"} align={"center"}>
                <BlackerBlueButton onClick={() => {
                    setOpenModal(true)
                }}>
                    <IntlMessage id={'create'}/>
                </BlackerBlueButton>
                <Upload {...propsExcelFile} fileList={uploadedFile ? [uploadedFile] : []}>
                    <GreenButton>
                        <IntlMessage id={'certificate.excelFormat'}/>
                    </GreenButton>
                </Upload>
                {
                    uploadedFile &&
                    <BhargaButton icon={<UploadOutlined/>} onClick={handleImportExcelFile}><IntlMessage id={'upload'}/></BhargaButton>
                }
            </Flex>
            <MyTable
                isLoading={isLoading || isLoadingCreate}
                dataSource={partnerOrgs}
                columns={columns}
                fetchData={fetchData}
                saveCurrentPage={saveCurrentPageSettings}
                initialPage={currentPage}
                initialPageSize={pageSize}
                hasMore={hasMore}
            />
            <Form form={form} className={classes.form} initialValues={{method: 'group'}}>
                <Modal
                    width={600}
                    maskClosable={true}
                    title={<IntlMessage id={'partnerOrg'}/>}
                    open={openModal}
                    onOk={handleCreate}
                    onCancel={() => {
                        setOpenModal(false)
                    }}
                    okText={<IntlMessage id={'create'}/>}
                    cancelText={<IntlMessage id={'close'}/>}
                >
                    <Flex vertical style={{width: '100%'}} gap={4}>
                        <FormItem rules={[{required: true, message: <IntlMessage id={'requiredField'}/>}]}
                                  label={t('nameRu')}
                                  labelCol={{span: 24}}
                                  className={classes.formInput} style={{width: '100%', padding: 0}} name="nameRu">
                            <Input rootClassName={classes.formInput}
                                   placeholder={IntlMessageText.getText({id: "nameRu"})}/>
                        </FormItem>
                        <FormItem rules={[{required: true, message: <IntlMessage id={'requiredField'}/>}]}
                                  label={t('nameKz')}
                                  labelCol={{span: 24}}
                                  className={classes.formInput} style={{width: '100%', padding: 0}} name="nameKz">
                            <Input rootClassName={classes.formInput}
                                   placeholder={IntlMessageText.getText({id: "nameKz"})}/>
                        </FormItem>
                        <FormItem rules={[{required: true, message: <IntlMessage id={'requiredField'}/>}]}
                                  label={t('nameEng')}
                                  labelCol={{span: 24}}
                                  className={classes.formInput} style={{width: '100%', padding: 0}} name="nameEng">
                            <Input rootClassName={classes.formInput}
                                   placeholder={IntlMessageText.getText({id: "nameEng"})}/>
                        </FormItem>
                        <FormItem
                            label={t('logo')}
                            labelCol={{span: 24}}
                            className={classes.formInput} style={{width: '100%', padding: 0}} name="image">
                            <Upload {...propsImageFile} fileList={uploadedImage ? [uploadedImage] : []}>
                                <GreenButton>
                                    <IntlMessage id={'file'}/>
                                </GreenButton>
                            </Upload>
                        </FormItem>
                        <Flex
                            gap={"small"}
                            justify={"flex-start"}
                            align={"baseline"}
                            vertical
                            style={{
                                padding: 8,
                                border: '1px solid white',
                                borderRadius: 8,
                                backgroundColor: "white"
                            }}
                        >
                            <IntlMessage id={'microQ.isAuthorApprover'}/>
                            <Form.Item
                                name={'firstName'}
                                className={classes.formInputBlock}
                                rules={[{required: true, message: t('requiredField')}]}
                            >
                                <Input placeholder={t('firstName')}/>
                            </Form.Item>
                            <Form.Item
                                name='middleName'
                                className={classes.formInputBlock}
                                rules={[{required: false, message: t('requiredField')}]}
                            >
                                <Input placeholder={t('middleName')}/>
                            </Form.Item>
                            <Form.Item
                                name='lastName'
                                className={classes.formInputBlock}
                                rules={[{required: true, message: t('requiredField')}]}
                            >
                                <Input placeholder={t('lastName')}/>
                            </Form.Item>
                            <Form.Item
                                name='firstNameEng'
                                className={classes.formInputBlock}
                                rules={[{required: true, message: t('requiredField')}]}
                            >
                                <Input placeholder={t('firstNameInEnglish')}/>
                            </Form.Item>
                            <Form.Item
                                name='lastNameEng'
                                className={classes.formInputBlock}
                                rules={[{required: false, message: t('requiredField')}]}
                            >
                                <Input placeholder={t('lastNameInEnglish')}/>
                            </Form.Item>
                            <Form.Item
                                name='positionRu'
                                className={classes.formInputBlock}
                                rules={[{required: true, message: t('requiredField')}]}
                                extra={t('example') + ': Главный менеджер / Генеральный директор'}
                            >
                                <Input placeholder={t('position') + ' ' + t('inRu')}/>
                            </Form.Item>
                            <Form.Item
                                name='positionKz'
                                className={classes.formInputBlock}
                                rules={[{required: true, message: t('requiredField')}]}
                                extra={t('example') + ': Бас менеджер / Генеральный директор'}
                            >
                                <Input placeholder={t('position') + " " + t('inKz')}/>
                            </Form.Item>
                            <Form.Item
                                name='positionEng'
                                className={classes.formInputBlock}
                                rules={[{required: true, message: t('requiredField')}]}
                                extra={t('example') + ': The general manager / CEO'}
                            >
                                <Input placeholder={t('position') + " " + t('inEng')}/>
                            </Form.Item>
                            <Form.Item
                                name='workPlaceRu'
                                className={classes.formInputBlock}
                                rules={[{required: true, message: t('requiredField')}]}
                                extra={t('example') + ': ЦКС Astana IT University / «Корпоративный университет» — ...'}
                            >
                                <Input placeholder={t('workPlace') + ' ' + t('inRu')}/>
                            </Form.Item>
                            <Form.Item
                                name='workPlaceKz'
                                className={classes.formInputBlock}
                                rules={[{required: true, message: t('requiredField')}]}
                                extra={t('example') + ': Astana IT University / «Корпоративный университет» — ...'}
                            >
                                <Input placeholder={t('workPlace') + " " + t('inKz')}/>
                            </Form.Item>
                            <Form.Item
                                name='workPlaceEng'
                                className={classes.formInputBlock}
                                rules={[{required: true, message: t('requiredField')}]}
                                extra={t('example') + ': CCE Astana IT University / Corporate University ...'}
                            >
                                <Input placeholder={t('workPlace') + " " + t('inEng')}/>
                            </Form.Item>
                        </Flex>
                    </Flex>
                </Modal>
            </Form>
        </Flex>
    );
};

export default PartnerOrganizationPage;